// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: mkq6PHJJELM

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Arrows from "../../Arrows"; // plasmic-import: W9XdlIeiuX/component
import SectionHeader from "../../SectionHeader"; // plasmic-import: Isc1ACYDLI/component

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSection.module.css"; // plasmic-import: mkq6PHJJELM/css

createPlasmicElementProxy;

export type PlasmicSection__VariantMembers = {
  contentHidden: "contentHidden";
  sectionSettingsOpen: "sectionSettingsOpen";
  headerHidden: "headerHidden";
  editMode: "editMode";
  unEditable: "unEditable";
};
export type PlasmicSection__VariantsArgs = {
  contentHidden?: SingleBooleanChoiceArg<"contentHidden">;
  sectionSettingsOpen?: SingleBooleanChoiceArg<"sectionSettingsOpen">;
  headerHidden?: SingleBooleanChoiceArg<"headerHidden">;
  editMode?: SingleBooleanChoiceArg<"editMode">;
  unEditable?: SingleBooleanChoiceArg<"unEditable">;
};
type VariantPropType = keyof PlasmicSection__VariantsArgs;
export const PlasmicSection__VariantProps = new Array<VariantPropType>(
  "contentHidden",
  "sectionSettingsOpen",
  "headerHidden",
  "editMode",
  "unEditable"
);

export type PlasmicSection__ArgsType = {
  sectionContent?: React.ReactNode;
  settingsPanel?: React.ReactNode;
};
type ArgPropType = keyof PlasmicSection__ArgsType;
export const PlasmicSection__ArgProps = new Array<ArgPropType>(
  "sectionContent",
  "settingsPanel"
);

export type PlasmicSection__OverridesType = {
  root?: p.Flex<"div">;
  arrows?: p.Flex<typeof Arrows>;
  freeBox?: p.Flex<"div">;
  sectionHeader?: p.Flex<typeof SectionHeader>;
  text?: p.Flex<"div">;
  span?: p.Flex<"span">;
  settingsPanelContainer?: p.Flex<"div">;
  sectionContentContainer?: p.Flex<"div">;
};

export interface DefaultSectionProps {
  sectionContent?: React.ReactNode;
  settingsPanel?: React.ReactNode;
  contentHidden?: SingleBooleanChoiceArg<"contentHidden">;
  sectionSettingsOpen?: SingleBooleanChoiceArg<"sectionSettingsOpen">;
  headerHidden?: SingleBooleanChoiceArg<"headerHidden">;
  editMode?: SingleBooleanChoiceArg<"editMode">;
  unEditable?: SingleBooleanChoiceArg<"unEditable">;
  className?: string;
}

const $$ = {};

function PlasmicSection__RenderFunc(props: {
  variants: PlasmicSection__VariantsArgs;
  args: PlasmicSection__ArgsType;
  overrides: PlasmicSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "contentHidden",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.contentHidden
      },
      {
        path: "sectionSettingsOpen",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.sectionSettingsOpen
      },
      {
        path: "headerHidden",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.headerHidden
      },
      {
        path: "editMode",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.editMode
      },
      {
        path: "unEditable",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.unEditable
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootcontentHidden]: hasVariant(
            $state,
            "contentHidden",
            "contentHidden"
          ),
          [sty.rooteditMode]: hasVariant($state, "editMode", "editMode"),
          [sty.rootsectionSettingsOpen]: hasVariant(
            $state,
            "sectionSettingsOpen",
            "sectionSettingsOpen"
          )
        }
      )}
    >
      <Arrows
        data-plasmic-name={"arrows"}
        data-plasmic-override={overrides.arrows}
        className={classNames("__wab_instance", sty.arrows, {
          [sty.arrowscontentHidden]: hasVariant(
            $state,
            "contentHidden",
            "contentHidden"
          ),
          [sty.arrowseditMode]: hasVariant($state, "editMode", "editMode"),
          [sty.arrowssectionSettingsOpen]: hasVariant(
            $state,
            "sectionSettingsOpen",
            "sectionSettingsOpen"
          )
        })}
      />

      <p.Stack
        as={"div"}
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxcontentHidden]: hasVariant(
            $state,
            "contentHidden",
            "contentHidden"
          ),
          [sty.freeBoxeditMode]: hasVariant($state, "editMode", "editMode"),
          [sty.freeBoxeditMode_contentHidden]:
            hasVariant($state, "contentHidden", "contentHidden") &&
            hasVariant($state, "editMode", "editMode"),
          [sty.freeBoxeditMode_sectionSettingsOpen]:
            hasVariant($state, "sectionSettingsOpen", "sectionSettingsOpen") &&
            hasVariant($state, "editMode", "editMode"),
          [sty.freeBoxsectionSettingsOpen]: hasVariant(
            $state,
            "sectionSettingsOpen",
            "sectionSettingsOpen"
          ),
          [sty.freeBoxunEditable]: hasVariant(
            $state,
            "unEditable",
            "unEditable"
          )
        })}
      >
        <SectionHeader
          data-plasmic-name={"sectionHeader"}
          data-plasmic-override={overrides.sectionHeader}
          className={classNames("__wab_instance", sty.sectionHeader, {
            [sty.sectionHeadercontentHidden]: hasVariant(
              $state,
              "contentHidden",
              "contentHidden"
            ),
            [sty.sectionHeadereditMode]: hasVariant(
              $state,
              "editMode",
              "editMode"
            ),
            [sty.sectionHeadereditMode_contentHidden]:
              hasVariant($state, "contentHidden", "contentHidden") &&
              hasVariant($state, "editMode", "editMode"),
            [sty.sectionHeadereditMode_sectionSettingsOpen]:
              hasVariant(
                $state,
                "sectionSettingsOpen",
                "sectionSettingsOpen"
              ) && hasVariant($state, "editMode", "editMode"),
            [sty.sectionHeaderheaderHidden]: hasVariant(
              $state,
              "headerHidden",
              "headerHidden"
            ),
            [sty.sectionHeadersectionSettingsOpen]: hasVariant(
              $state,
              "sectionSettingsOpen",
              "sectionSettingsOpen"
            ),
            [sty.sectionHeaderunEditable]: hasVariant(
              $state,
              "unEditable",
              "unEditable"
            )
          })}
          sectionTitle={
            <div
              data-plasmic-name={"text"}
              data-plasmic-override={overrides.text}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text,
                {
                  [sty.textcontentHidden]: hasVariant(
                    $state,
                    "contentHidden",
                    "contentHidden"
                  ),
                  [sty.texteditMode]: hasVariant(
                    $state,
                    "editMode",
                    "editMode"
                  ),
                  [sty.textsectionSettingsOpen]: hasVariant(
                    $state,
                    "sectionSettingsOpen",
                    "sectionSettingsOpen"
                  )
                }
              )}
            >
              {hasVariant($state, "editMode", "editMode") ? (
                "Youtube - Programming \u2328\ufe0f"
              ) : hasVariant(
                  $state,
                  "sectionSettingsOpen",
                  "sectionSettingsOpen"
                ) ? (
                "Youtube - Programming \u2328\ufe0f"
              ) : (
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <span
                      data-plasmic-name={"span"}
                      data-plasmic-override={overrides.span}
                      className={classNames(
                        projectcss.all,
                        projectcss.span,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.span
                      )}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#5978E8" }}
                        >
                          {"Hub"}
                        </span>
                        <React.Fragment>{""}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#FDFBF7" }}
                        >
                          {"Hub"}
                        </span>
                      </React.Fragment>
                    </span>
                  }
                  <React.Fragment>{""}</React.Fragment>
                  <span
                    className={"plasmic_default__all plasmic_default__span"}
                    style={{ color: "#FDFBF7" }}
                  >
                    {" "}
                  </span>
                  <React.Fragment>{"tipps"}</React.Fragment>
                </React.Fragment>
              )}
            </div>
          }
          variant={
            hasVariant($state, "sectionSettingsOpen", "sectionSettingsOpen") &&
            hasVariant($state, "editMode", "editMode")
              ? "sectionSettings"
              : hasVariant($state, "unEditable", "unEditable")
              ? "unEditable"
              : hasVariant($state, "editMode", "editMode")
              ? "editMode"
              : hasVariant($state, "sectionSettingsOpen", "sectionSettingsOpen")
              ? "sectionSettings"
              : "_default"
          }
        />

        <div
          data-plasmic-name={"settingsPanelContainer"}
          data-plasmic-override={overrides.settingsPanelContainer}
          className={classNames(projectcss.all, sty.settingsPanelContainer, {
            [sty.settingsPanelContainercontentHidden]: hasVariant(
              $state,
              "contentHidden",
              "contentHidden"
            ),
            [sty.settingsPanelContainereditMode]: hasVariant(
              $state,
              "editMode",
              "editMode"
            ),
            [sty.settingsPanelContainersectionSettingsOpen]: hasVariant(
              $state,
              "sectionSettingsOpen",
              "sectionSettingsOpen"
            )
          })}
        >
          {p.renderPlasmicSlot({
            defaultContents: null,
            value: args.settingsPanel
          })}
        </div>
        {(
          hasVariant($state, "sectionSettingsOpen", "sectionSettingsOpen") &&
          hasVariant($state, "editMode", "editMode")
            ? true
            : hasVariant($state, "contentHidden", "contentHidden") &&
              hasVariant($state, "editMode", "editMode")
            ? false
            : hasVariant($state, "sectionSettingsOpen", "sectionSettingsOpen")
            ? true
            : hasVariant($state, "contentHidden", "contentHidden")
            ? true
            : true
        ) ? (
          <p.Stack
            as={"div"}
            data-plasmic-name={"sectionContentContainer"}
            data-plasmic-override={overrides.sectionContentContainer}
            hasGap={true}
            className={classNames(projectcss.all, sty.sectionContentContainer, {
              [sty.sectionContentContainercontentHidden]: hasVariant(
                $state,
                "contentHidden",
                "contentHidden"
              ),
              [sty.sectionContentContainereditMode]: hasVariant(
                $state,
                "editMode",
                "editMode"
              ),
              [sty.sectionContentContainereditMode_contentHidden]:
                hasVariant($state, "contentHidden", "contentHidden") &&
                hasVariant($state, "editMode", "editMode"),
              [sty.sectionContentContainereditMode_sectionSettingsOpen]:
                hasVariant(
                  $state,
                  "sectionSettingsOpen",
                  "sectionSettingsOpen"
                ) && hasVariant($state, "editMode", "editMode"),
              [sty.sectionContentContainersectionSettingsOpen]: hasVariant(
                $state,
                "sectionSettingsOpen",
                "sectionSettingsOpen"
              )
            })}
          >
            {p.renderPlasmicSlot({
              defaultContents: null,
              value: args.sectionContent
            })}
          </p.Stack>
        ) : null}
      </p.Stack>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "arrows",
    "freeBox",
    "sectionHeader",
    "text",
    "span",
    "settingsPanelContainer",
    "sectionContentContainer"
  ],
  arrows: ["arrows"],
  freeBox: [
    "freeBox",
    "sectionHeader",
    "text",
    "span",
    "settingsPanelContainer",
    "sectionContentContainer"
  ],
  sectionHeader: ["sectionHeader", "text", "span"],
  text: ["text", "span"],
  span: ["span"],
  settingsPanelContainer: ["settingsPanelContainer"],
  sectionContentContainer: ["sectionContentContainer"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  arrows: typeof Arrows;
  freeBox: "div";
  sectionHeader: typeof SectionHeader;
  text: "div";
  span: "span";
  settingsPanelContainer: "div";
  sectionContentContainer: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSection__VariantsArgs;
    args?: PlasmicSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSection__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSection__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSection__ArgProps,
          internalVariantPropNames: PlasmicSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSection";
  } else {
    func.displayName = `PlasmicSection.${nodeName}`;
  }
  return func;
}

export const PlasmicSection = Object.assign(
  // Top-level PlasmicSection renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    arrows: makeNodeComponent("arrows"),
    freeBox: makeNodeComponent("freeBox"),
    sectionHeader: makeNodeComponent("sectionHeader"),
    text: makeNodeComponent("text"),
    span: makeNodeComponent("span"),
    settingsPanelContainer: makeNodeComponent("settingsPanelContainer"),
    sectionContentContainer: makeNodeComponent("sectionContentContainer"),

    // Metadata about props expected for PlasmicSection
    internalVariantProps: PlasmicSection__VariantProps,
    internalArgProps: PlasmicSection__ArgProps
  }
);

export default PlasmicSection;
/* prettier-ignore-end */
